// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    engineeringButtonText: "Get Started",
    engineeringTabH2: "Ship quality software faster with AI-guided sprints",
    engineeringTabTagline: "PRODUCT & ENGINEERING",
    engineeringUsecase1: "AI assistant",
    engineeringUsecase2: "AI agents",
    engineeringUsecase3: "Roadmap planning",
    engineeringUsecase4: "Bug triage",
    engineeringUsecase5: "Sprint management",
    engineeringUsecase6: "Build your own app",
    itButtonText: "Get Started",
    itSupportTabTitle: "IT & Support",
    itTabH2: "Deliver proactive, intelligent service at scale",
    itTabTagline: "IT & SUPPORT",
    itUsecase1: "AI assistant",
    itUsecase2: "AI agents",
    itUsecase3: "Ticket triage",
    itUsecase4: "Escalation workflow",
    itUsecase5: "Service portal",
    itUsecase6: "Build your own app",
    marketingButtonText: "Get Started",
    marketingTabH2: "AI-powered marketing that drives demand",
    marketingTabTagline: "Marketing",
    marketingTabTitle: "Marketing",
    marketingUsecase1: "AI assistant",
    marketingUsecase2: "AI agents",
    marketingUsecase3: "Campaign management",
    marketingUsecase4: "Content calendar",
    marketingUsecase5: "Build your own marketing app",
    pmoOperationsTagline: "PMO & Operations",
    pmoOpsButtonText: "Get Started",
    pmoOpsTabH2: "Deliver strategic initiatives on time with clarity and predictability",
    pmoOpsTabTitle: "PMO & Ops",
    pmoUsecase1: "AI risk analyzer",
    pmoUsecase2: "AI assistant",
    pmoUsecase3: "Projects & portfolio",
    pmoUsecase4: "AI agents",
    pmoUsecase5: "Build your own app",
    pmoUsecase6: "AI reporting",
    productEngineeringTabTitle: "Product & Engineering",
    salesButtonText: "Get Started",
    salesRevenueTabTitle: "Sales & Revenue",
    salesTabH2: "Accelerate revenue through a connected AI-driven customer journey",
    salesTabTagline: "sales & revenue",
    salesUsecase1: "Deal insights",
    salesUsecase2: "AI sales agents",
    salesUsecase3: "Build your own app",
    salesUsecase4: "AI notetaker",
    salesUsecase5: "AI email generator",
    salesUsecase6: "Activity tracker",
    sectionSubtitle: "Keep your teams aligned and work moving with purpose-built solutions for every function, connected on one intelligent platform",
    sectionTitle: "Solutions for every team, powered by AI"
};
